import React, { useMemo, useState } from 'react';
import RecordingItem from './RecordingItem';

const RecordingTable = ({ recordings, onPlay, onDownload }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const pageSize = 5;

  const filtered = useMemo(() => {
    return recordings.filter((r) =>
      r.title.toLowerCase().includes(search.toLowerCase())
    );
  }, [recordings, search]);

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const pageItems = filtered.slice((page - 1) * pageSize, page * pageSize);

  const changePage = (p) => {
    if (p < 1 || p > totalPages) return;
    setPage(p);
  };

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <span>Recordings</span>
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: 250 }}
          placeholder="Search by title..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPage(1);
          }}
        />
      </div>
      <div className="card-body p-0">
        <div className="table-responsive">
          <table className="table table-striped mb-0">
            <thead>
              <tr>
                <th>Title</th>
                <th>Date</th>
                <th>Duration</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {pageItems.map((rec) => (
                <RecordingItem
                  key={rec.id}
                  recording={rec}
                  onPlay={onPlay}
                  onDownload={onDownload}
                />
              ))}
              {pageItems.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center text-muted py-3">
                    No recordings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      {totalPages > 1 && (
        <div className="card-footer d-flex justify-content-between align-items-center">
          <span>
            Page {page} of {totalPages}
          </span>
          <div>
            <button
              className="btn btn-sm btn-outline-secondary me-2"
              onClick={() => changePage(page - 1)}
            >
              Prev
            </button>
            <button
              className="btn btn-sm btn-outline-secondary"
              onClick={() => changePage(page + 1)}
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecordingTable;
